import { Component, NgModule, Input, ViewChild, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DxListModule } from 'devextreme-angular/ui/list';
import { DxDropDownButtonComponent, DxDropDownButtonModule } from 'devextreme-angular/ui/drop-down-button';
import { DxContextMenuModule } from 'devextreme-angular/ui/context-menu';
import { LanguageService } from '../../../services/language.service';
import { Languages } from '../../../classes/infrastructure/enums';
import { UserLanguagePreferenceRequest } from '../../../classes/infrastructure/request_response/updateuserlanguagepreference';
import { ServerCommunicatorService } from '../../../services/server-communicator.service';
import { UIUtils } from '../../../services/uiutils.service';
import { AppStateManageService } from '../../../services/app-state-manage.service';

@Component({
  selector: 'app-user-panel',
  templateUrl: 'user-panel.component.html',
  styleUrls: ['./user-panel.component.scss'],
  standalone: false
})

export class UserPanelComponent {
  @Input() menuMode = 'context';
  @Input() menuItems: any[] = [];
  @Input() profileImage: string | null = null;

  @ViewChild(DxDropDownButtonComponent) dropDownBtn!: DxDropDownButtonComponent;

  langSubmenuVisible = false;
  dropdownOpen = false;

  constructor(public langService: LanguageService, private servercommunicator: ServerCommunicatorService, private uiUtils: UIUtils, private appStateManage: AppStateManageService,) { }
  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  // Close on outside click
  @HostListener('document:click')
  onDocumentClick() {
    this.dropdownOpen = false;
  }

  handleItemClick(item: any) {
    if (item.disabled) return;
    this.dropdownOpen = false;
    if (item.onClick) {
      item.onClick();
    }
  }

  // selectLang(lang: 'en' | 'mr') {
  //   this.langService.switchLanguage(lang);
  //   this.dropdownOpen = false;
  // }

  async selectLang(lang: 'en' | 'mr') {
  this.langService.switchLanguage(lang);
  this.dropdownOpen = false;

  // const loginUserRef = Number(localStorage.getItem('LoginUserRef') || 0);
  const loginUserRef = this.appStateManage.getLoginUserRef();
  console.log('loginUserRef :', loginUserRef);
  const langEnumValue = lang === 'mr' ? Languages.Marathi : Languages.English;
  console.log('langEnumValue :', langEnumValue);

  const req = new UserLanguagePreferenceRequest();
  req.asha_employee_record_id = loginUserRef;
  req.from_language = langEnumValue;

  // await this.servercommunicator.LanguagePreferenceUser(req);

  const result = await this.servercommunicator.LanguagePreferenceUser(req);
  console.log('result :', result);

    if (!result.Successful) {
      await this.uiUtils.showErrorMessage('Error', result.Message || 'Failed to update language preference.');
    }
}

}

@NgModule({
  imports: [
    DxListModule,
    DxContextMenuModule,
    DxDropDownButtonModule,
    CommonModule
  ],
  declarations: [UserPanelComponent],
  exports: [UserPanelComponent]
})
export class UserPanelModule { }
